import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import { useCallback, useMemo } from 'react';
import IDeleteBranchModalProps from './interfaces/IDeleteBranchModalProps';

function DeleteBranchModal({
    opened,
    branches,
    closeModalCallback,
    deleteCancelCallback,
    deleteConfirmedCallback,
}: Readonly<IDeleteBranchModalProps>) {
    const getSelectedBranches = useCallback(
        () => branches.filter(b => b.checked),
        [branches],
    );

    const modalMessage = useMemo(() => {
        const selectedBranches = getSelectedBranches();

        return selectedBranches.length > 1
            ? 'as filiais selecionadas serão excluídas'
            : 'a filial selecionada será excluída';
    }, [getSelectedBranches]);

    const modalTitle = useMemo(() => {
        const selectedBranches = getSelectedBranches();

        return selectedBranches.length > 1 ? 'Filiais' : 'Filial';
    }, [getSelectedBranches]);

    return (
        <ClbModal
            title={`Excluir ${modalTitle}?`}
            open={opened}
            onClose={closeModalCallback}
            description={`Ao confirmar essa ação, ${modalMessage}.`}
            type="danger"
            itemsFooter={[
                {
                    key: 'delete-button',
                    id: 'delete-button',
                    label: `Apagar ${modalTitle}`,
                    disabled: false,
                    loading: false,
                    title: 'Realizar exclusão',
                    'data-testid': 'modal-delete-button',
                    onClick: () => deleteConfirmedCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'danger',
                },
                {
                    key: 'delete-branch-cancel-button',
                    id: 'delete-branch-cancel-button',
                    label: 'Cancelar',
                    disabled: false,
                    loading: false,
                    title: 'Cancelar exclusão',
                    'data-testid': 'delete-branch-cancel-button',
                    onClick: () => deleteCancelCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'secondary',
                },
            ]}
        />
    );
}

export default DeleteBranchModal;
